import { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ApiInstance } from "../api/instance";
import { useAppSelector } from "../hooks/useAppSelector";

/** Cohort routing only: dedicated campaign/legal routes are never intercepted. */
export function ConsumerEntry({
  mode,
  children,
}: {
  mode: "landing" | "feed";
  children: ReactNode;
}) {
  const owner = useAppSelector((s) => s.auth.user?.id);
  const [destination, setDestination] = useState<
    "loading" | "new" | "legacy" | "error"
  >("loading");
  useEffect(() => {
    if (mode === 'landing') { setDestination('legacy'); return; }
    let active = true;
    setDestination("loading");
    const endpoint = "account";
    ApiInstance.get(`/api/consumers/settlement-experience/${endpoint}`)
      .then(({ data }) => {
        if (active)
          setDestination(
            data.member
              ? "new"
              : "legacy",
          );
      })
      .catch((error) => {
        // Old backends can serve the legacy app during a coordinated rollout.
        if (active)
          setDestination(
            error.response?.status === 404
              ? "legacy"
              : "error",
          );
      });
    return () => {
      active = false;
    };
  }, [mode, owner]);
  if (destination === "new")
    return <Navigate to="/settlement-assistant" replace />;
  if (destination === "legacy") return <>{children}</>;
  return (
    <div className="settlements-app">
      <main className="sa-main">
        <p role={destination === "error" ? "alert" : "status"}>
          {destination === "error"
            ? "We couldn’t load your account. Please try again."
            : "Opening your Fairday…"}
        </p>
        {destination === "error" && (
          <button
            className="sa-primary"
            onClick={() => window.location.reload()}
          >
            Try again
          </button>
        )}
      </main>
    </div>
  );
}
